import { adminInstance } from "@/api/instance";

export default async function (b4aId) {
  return adminInstance.patch(`/b4a/${b4aId}`);
}